import   React                  ,
       { useEffect              ,
         useState               }  from "react";

import   classNames                from "classnames";

import   styles                    from "./PaymentList.module.scss";

import   TabularDisplay            from "../../widget/dataDisplay/tables/TabularDisplay";
import   BarGraph                  from "../../widget/dataDisplay/charts/BarGraph";
import   WidgetFrame               from '../../widget/navigation/WidgetFrame';
import   Select                    from '../../widget/inputs/Select';
import   DateTimeRangePicker       from "../../widget/inputs/DateTimeRangePicker";
import   Field                     from "../../widget/inputs/Field";
import   OpenStreetMap             from "../../widget/dataDisplay/maps/OpenStreetMap";
import   ExtendablePanel           from "../../widget/windows/ExtendablePanel";
import   AnimatedWaitingIcon2      from '../../widget/animations/animatedWaitingIcon2';
import   Box                       from '../../widget/windows/Box';

import   UserInformations2         from '../userManagment/UserInformations2'
import   ProductSheet              from '../productManagment/ProductSheet'

import { useWindowSize          }     from "../../widget/windows/hooks";

import { groupData              ,
         generateStats          ,
         completeGroupData      ,
         generateChartData      }  from "../../../dataTypes/dataSetManagment/regroupData";

import { Coordinate             }  from "../../../dataTypes/geolocationManagment/types"

import { Product         }  from "../../../dataTypes/productManagment/types";
		 

import { GetPaymentListParams   ,
         EnrichedPayment        }  from "../../../dataTypes/paymentManagment/types";

import { getEnrichedPaymentList }  from "../../../backendServices/paymentManagment/api";

import { getProducts            }  from '../../../backendServices/productManagment/api_product';
		 
import { convertDateToString    ,
         convertStringToDate    }  from "../../../dataTypes/timeManagment/utils";

export interface EnrichedPayment2 extends EnrichedPayment {

  userId: number;
  userEmail: string;
  userFirstname: string;
  userLastname: string;
}

interface LiveStatsProps {
  userEmail? : string;
  userId?    : number;
  userCreationDate? : Date;
}

export const PaymentList: React.FC<LiveStatsProps> = ({ userEmail, userId , userCreationDate}) => {

  const sortTypes        = ["Date de paiement", "Montant", "Statut"];

  const now              = new Date();
  const startOfYesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 0, 0, 0);
  const startOfTomorrow  = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);

  const startOfTwoMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 2, 1, 0, 0, 0);

  const [ products             , setProducts] = useState<Product[]>([]);
  const [ paymentList          , setPaymentList          ] = useState<EnrichedPayment[]>([]);
  const [ filteredPaymentList  , setFilteredPaymentList  ] = useState<EnrichedPayment[]>([]);
  const [ paymentList2         , setPaymentList2         ] = useState<EnrichedPayment2[]>([])
  const [ filteredPaymentList2 , setFilteredPaymentList2 ] = useState<EnrichedPayment2[]>([]);
  const [ coordinates          , setCoordinates          ] = useState<Coordinate[]>([]);
  const [ startDate            , setStartDate            ] = useState<Date | null>( (userId || userEmail) ? userCreationDate ?? null : startOfTwoMonthsAgo ?? null );
  const [ endDate              , setEndDate              ] = useState<Date | null>(now);
  const [ showWaitingIcon      , setShowWaitingIcon      ] = useState(false);

  const [sortType              , setSortType             ] = useState(sortTypes[0]);
  const [filter                , setFilter               ] = useState("");

  const [  , setResultSectionWidth ] = useState(800);
  const [ chartWidth         , setChartWidth         ] = useState(800 * 0.6);
  const [ mapWidth           , setMapWidth           ] = useState(800 * 0.35);
  const [ ready              , setReady              ] = useState(false);
  const [ userToShow         , setUserToShow         ] = useState<number>(0);
  const [ productToShow      , setProductToShow      ] = useState<Product|null>(null);

  const { width } = useWindowSize(); 

  useEffect(() => {
    
    const newWidth = width-200 || 800; // fallback si width est undefined
    setResultSectionWidth(newWidth);
    setChartWidth(newWidth * 0.6);
    setMapWidth(newWidth * 0.35);
    setReady(true);
  }, [width]); 

  const fetchData = async (params: GetPaymentListParams = {})  => {

    try
     {
      setShowWaitingIcon(true);

      const updatedParams: GetPaymentListParams = {
        ...params,
        userEmail,
        userId,
        beginningDate : startDate ?? startOfYesterday,
        endingDate    : endDate   ?? startOfTomorrow
      };

      const [paymentsResult, productsResult] = await Promise.all([
          getEnrichedPaymentList(updatedParams),
          getProducts("Tous")
      ]);


      if (paymentsResult.payload)
       {
        setPaymentList(paymentsResult.payload);
        setFilteredPaymentList(paymentsResult.payload);

        const paymentList2: EnrichedPayment2[] = paymentsResult.payload.map(payment => ({
          ...payment,
          userId           : payment.purchase?.userId ?? 0, 
          userEmail        : payment.purchase?.user?.email ?? "", 
          userFirstname    : payment.purchase?.user?.firstname ?? "", 
          userLastname     : payment.purchase?.user?.lastname ?? "", 
        }));

        setPaymentList2         ( paymentList2 )
        // Le texte du filtre reste affiché : la liste rechargée doit continuer à en tenir compte.
        setFilteredPaymentList2 ( filterPayments2(filter, paymentList2) );
       }
	   
        if (productsResult.code === 1) 
		 {
          setProducts(productsResult.payload);
         }
     }
    catch (error)
     {
      console.error("Error fetching data:", error);
     }
    finally
     {
      setShowWaitingIcon(false);
     }
  };

  useEffect(() => {
    fetchData();
  }, [userEmail, userId, startDate, endDate]);

  useEffect(() => {

    console.log (PaymentList)

    const coords = paymentList.map(payment => ({
        lat   : payment.purchase?.ipDetails?.ipApiCom_lat  ?? 0,
        lng   : payment.purchase?.ipDetails?.ipApiCom_lon  ?? 0,
 //       info1 : `${convertDateToString (payment.creationDate, 'dd/MM/yyyy HH:mm:ss') || "N/A"} , ${(payment.amount/100).toFixed(2)} €`,
        info1 : `${payment.creationDate?.toLocaleString() ?? "N/A"} , ${(payment.amount/100).toFixed(2)} €`,
        info2 : `${payment.purchase?.user?.firstname ?? "N/A"} ${payment.purchase?.user?.lastname ?? "N/A"}`,
		color : 'violet'
      }));

      setCoordinates(coords);

  }, [paymentList2]);


  const filterPayments2 = (filterText: string, source: EnrichedPayment2[] = paymentList2): EnrichedPayment2[] => {
    let filteredPayments = source;

    if (filterText !== "") {
      const filterTextLowerCase = filterText.toLowerCase();

      filteredPayments = filteredPayments.filter(
        (payment) =>
          payment.paymentReference?.toLowerCase().includes(filterTextLowerCase) ||
          payment.status?.toLowerCase().includes(filterTextLowerCase) ||
          payment.purchase?.user?.email.toLowerCase().includes(filterTextLowerCase) ||
          payment.purchase?.user?.firstname.toLowerCase().includes(filterTextLowerCase) ||
          payment.purchase?.user?.lastname.toLowerCase().includes(filterTextLowerCase) 
      );
    }

    return filteredPayments;
  };

  const getItemName = (productId: number , productVariantId: number): string | null  => {
	  
	let name: string | null = null  
	  
	if ( productId !== 0 )
	 {
      for (let l = 0; l < products.length; l++) 
	   {
        if (products[l].id === productId) 
		 {
	      if ( productVariantId !== 0 )
	       {
            for (let k = 0; k < products[l].variants.length; k++) 
	         {
              if (products[l].variants[k].id === productVariantId) 
		       {
                return products[l].variants[k].name;
			   }
			 }
		   }
		    else {
			      return products[l].name;
		         }
         }
       }
	 }
    return name;
  };

  const getProduct = (productId: number ): Product | null  => {
	  
	if ( productId !== 0 )
	 {
      for (let l = 0; l < products.length; l++) 
	   {
        if (products[l].id === productId) 
		 {
          return products[l];
         }
       }
	 }

    return null;
  };


  const formatAmount = ( amount: number, withSymbole: boolean = true): string => {

      const formattedPrice = (amount / 100).toFixed(2) + ( withSymbole ? " €" : "" );

    return formattedPrice;
  }

  const formatStatus = ( status: string): string => {

    let formattedStatus = status

         if ( status === 'Fail' ) { formattedStatus = 'Echec'    }
    else if ( status === 'Paid' ) { formattedStatus = 'Payé'     }
    else if ( status === 'New'  ) { formattedStatus = 'Non payé' }

    return formattedStatus;
  }

  const handleSpanClick = (userId:number) => {
	  
    console.log(`Affiche infos du user ${userId}`); // Add semicolon here

    setUserToShow (userId)
  }
  
  const handleClose = () => {
	  
    setUserToShow (0)
    setProductToShow (null)
  }

  var columns = [
    { 
	  header: "Référence"        , 
	  accessor: "paymentReference" as keyof EnrichedPayment2 , 
	  width: '110px' 
	},
    { 
	  header: "UserId"           , 
	  accessor: "userId"           as keyof EnrichedPayment2 , 
	  width: '70px'  , 
	  cellRenderer: (value: any) => (<span onClick={() => handleSpanClick(value)} style={{ textDecoration: 'underline'  , cursor: 'pointer' }}>{value}</span>) 
	},
    { 
	  header: "Email"            , 
	  accessor: "userEmail"        as keyof EnrichedPayment2 
	},
    { 
	  header: "Prénom"           , 
	  accessor: "userFirstname"    as keyof EnrichedPayment2 ,
	  width: '100px' 
    },
    { 
	  header: "Nom"              , 
	  accessor: "userLastname"     as keyof EnrichedPayment2 , width: '100px' 
    },
    { 
	  header: "Montant"          , 
	  accessor: "amount"           as keyof EnrichedPayment2 , 
	  width: '100px' , cellRenderer: (value: any) => (<span>{formatAmount(value as number)}</span>) 
	},
    { 
	  header: "Statut"           , 
	  accessor: "status"           as keyof EnrichedPayment2 , 
	  width: '80px'  , 
	  cellRenderer: (value: any) => (<span>{formatStatus(value as string)}</span>) 
	},
    { 
	  header: "Date de paiement" , 
	  accessor: "creationDate"     as keyof EnrichedPayment2 , 
	  width: '150px' , 
	  cellRenderer: (value: any) => (<span>{value.toLocaleString()}</span>) 
	},
	{ 
	  header: "Moyen de paiement" , 
	  accessor: "meansOfPayment"     as keyof EnrichedPayment2 , 
	  width: '150px' 
	}
	
	
  ];

  if ( userId || userEmail )
   {
    columns = [
       { header: "Référence"        , accessor: "paymentReference" as keyof EnrichedPayment2 , width: '110px'},
       { header: "Montant"          , accessor: "amount"           as keyof EnrichedPayment2 , width: '100px', cellRenderer: (value: any) => (<span>{formatAmount(value as number)}</span>) },
       { header: "Statut"           , accessor: "status"           as keyof EnrichedPayment2 , width: '80px', cellRenderer: (value: any) => (<span>{formatStatus(value as string)}</span>) },
	   { header: "Date de paiement" , accessor: "creationDate"     as keyof EnrichedPayment2 , width: '150px', cellRenderer: (value: any) => (<span>{value.toLocaleString()}</span>) },
       { 
	     header: "Moyen de paiement" , 
	     accessor: "meansOfPayment"     as keyof EnrichedPayment2 , 
	     width: '150px' 
	   }	   
     ];
   }
   
const getGroupKey = (sortType: string) => {
  switch (sortType) {

      /*
      case sortTypes[0] : return (payment: EnrichedPayment) => ({
                                                          key      : `${convertDateToString (payment.creationDate, "yyyy/MM/dd HH:mm")}`,
                                                          renderer : (payment: EnrichedPayment) => `${convertDateToString (payment.creationDate, "dd/MM/yyyy HH:mm")}`
                                                       });
      */

    case sortTypes[0]:
      return (payment: EnrichedPayment2) => ({
        key      : `${convertDateToString (payment.creationDate, "yyyy/MM/dd")}`,
        renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd"), "dd/MM/yyyy")}`
      });

    case sortTypes[1]:
      return (payment: EnrichedPayment2) => ({
        key: formatAmount ( payment.amount , false ), // payment.(amount/100).toFixed(2),
        renderer: (val: string) => val + '€', // <-- Correction ici
      });

    case sortTypes[2]:
      return (payment: EnrichedPayment2) => ({
        key: payment.status,
        renderer: (val: string) => formatStatus (val),
      });

    default:
      throw new Error(`Unknown sort type: ${sortType}`);
  }
};

/*
  const groupedData        = groupData<EnrichedPayment> (filteredPaymentList, getGroupKey(sortType));
  const completedGroupData = completeGroupData<EnrichedPayment> (groupedData, "1 jour");
  const statsResult        = generateStats<EnrichedPayment> ( completedGroupData , () => 1 , (a, b) => a + b );
  const chartData          = generateChartData<EnrichedPayment> ( statsResult, completedGroupData);
*/

  const groupedData        = groupData<EnrichedPayment2> (filteredPaymentList2, getGroupKey(sortType));
const completedGroupData =
  startDate && endDate
    ? completeGroupData<EnrichedPayment2>(groupedData, "1 jour", startDate, endDate)
    : completeGroupData<EnrichedPayment2>(groupedData, "1 jour");
  const statsResult        = generateStats<EnrichedPayment2> ( completedGroupData , () => 1 , (a, b) => a + b );
  const chartData          = generateChartData<EnrichedPayment2> ( statsResult, completedGroupData);





  const handleDateRangeChange = (start: string, end: string) => {

    const date1 = convertStringToDate(start,'dd/MM/yyyy');
    const date2 = convertStringToDate(end,'dd/MM/yyyy');

    console.log ('handleDateRangeChange', date1, date2)

    setStartDate(date1);
    setEndDate(date2);
  };

  const handleSortTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSortType(e.target.value);
  };

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
	  
    const newFilter = e.target.value;
    setFilter(newFilter);
 // setFilteredPaymentList(filterPayments(newFilter));
    setFilteredPaymentList2(filterPayments2(newFilter));
  };

  const generateBarGraphSubTitle = () : string => {

    const date1 = convertDateToString (startDate ,'dd/MM/yyyy')
    const date2 = convertDateToString (endDate   ,'dd/MM/yyyy')

  /*
    let timeStepTitle : string = ""

    for (let i =0; i<timeStepNames.length ; i++)
     {
      if ( timeStep === timeStepNames [i] )
       {
        timeStepTitle = timeStepTitles [i]
        break;
       }
     }
  */

   const timeStepTitle = "par jour"

   return `Du ${date1} au ${date2} ${timeStepTitle}`
  }

//      <div ref={filterSectionRef} className={styles.filterSection}>

  const handleProductIdClick = (productId:number) => {
      
    console.log(`Affiche infos du product ${productId}`); // Add semicolon here

    setProductToShow ( getProduct (productId) ) }
  

  return (

    <div className={styles.root}>
      {showWaitingIcon && <AnimatedWaitingIcon2 />}


	  {
	   userToShow !== 0 &&
	   (
        <Box width="95vw" height="95vh" onClose={handleClose} logo={true} >
          <UserInformations2 userId={userToShow} />
        </Box>
       )
      }

	  {
	   productToShow !== null &&
	   (
        <Box width="95vw" height="95vh" onClose={handleClose} logo={true} >
          <ProductSheet product={productToShow}/>
        </Box>
       )
      }

      {/* Bloc 1 : Plage de dates et bouton Rafraîchir */}

      <div className={styles.filterSection}>

        <div className={styles.filters}>

          <WidgetFrame name               = "Plage de paiement :"
                       labelTextPosition  = "left"
                       labelBlockPosition = "left"
                       classNameGrid      = {classNames(styles.grid_frame)} >
            <DateTimeRangePicker onChange      = {handleDateRangeChange}
                                 showHourPanel = {false}
                                 labelColor    = "#000000"
                                 startDate     = {convertDateToString(startDate,'dd/MM/yyyy')}
                                 endDate       = {convertDateToString(endDate  ,'dd/MM/yyyy')} />
          </WidgetFrame>

          <WidgetFrame name               = "Rechercher :"
                       labelTextPosition  = "left"
                       labelBlockPosition = "left"
                       classNameGrid      = {classNames(styles.grid_frame)} >
            <Field type        = "text"
                   placeholder = ""
                   value       = {filter}
                   onChange    = {handleFilterChange} />
          </WidgetFrame>

          <WidgetFrame name               = "Echelle :"
                       labelTextPosition  = "left"
                       labelBlockPosition = "left"
                       classNameGrid      = {classNames(styles.grid_frame)} >
            <Select choices  = {sortTypes}
                    value    = {sortType}
                    onChange = {handleSortTypeChange} />
          </WidgetFrame>

        </div>

      </div>

      {/* Bloc 2 et 3 : Affichage conditionnel des données */}

      {
       ready &&
       (
        paymentList.length === 0
        ?
        (
         <div className={styles.noDataMessage}>
          Aucune donnée à afficher pour la période considérée
         </div>
        )
        :
        (
         <div className={styles.resultSection}>
           <div className={styles.dataDisplaySection}>
             <div className={styles.chartSection}>
               <ExtendablePanel width={chartWidth} height={mapWidth} logoUrl="/images/logo.png">
                 <BarGraph data={chartData} title={`${filteredPaymentList.length} paiements effectués sur la plateforme`}
                 subTitle = {generateBarGraphSubTitle()} paddingBottom={70}/>
               </ExtendablePanel>
             </div>
             <div className={styles.mapSection}>
               <ExtendablePanel width={mapWidth} height={mapWidth} logoUrl="/images/logo.png" logoPosition="bottomLeft">
                 <OpenStreetMap coordinates={coordinates} />
               </ExtendablePanel>
             </div>
           </div>
           <div className={styles.tableSection}>
             <TabularDisplay groupedData       = {groupedData}
                             columns           = {columns} 
							 rowDetailRenderer = { rowData => (
                                                                <table className={styles.subTable}>
                                                                 <thead>
                                                                  <tr>
                                                                   <th>Produit</th>
                                                                   <th>HT</th>
                                                                   <th>TVA</th>
                                                                   <th>TTC</th>
                                                                   <th>Quantité</th>
                                                                   <th>Total</th>
																  </tr>
                                                                 </thead>
                                                                 <tbody>
                                                                  {
                                                                   rowData.purchase.cart.map ((item, index) => (
                                                                    <tr key={index}>
                                                                     <td>{ getItemName (item.productId, item.productVariantId) } &nbsp;
																	       (<span onClick={() => handleProductIdClick(item.productId)} style={{ textDecoration: 'underline'  , cursor: 'pointer' }}>{item.productId}</span>)</td>
                                                                     <td>{ (item.basePriceCopy/100).toFixed(2) } €</td>
                                                                     <td>{ (item.taxRateCopy/100).toFixed(2) } %</td>
                                                                     <td>{ (item.priceToPayCopy/100).toFixed(2) } €</td>
                                                                     <td>{  item.quantity.toString()         }</td>
                                                                     <td>{ (item.totalPrice/100).toFixed(2) }€ </td>                                                                                                                                         </tr>
                                                                   ))
                                                                  }
                                                                 </tbody>
                                                                </table>
                                                               ) } />
           </div>
         </div>
        )
       )
      }
    </div>
  );


};

export default PaymentList;
